import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

interface BillingPartiesData {
    myBillingParties?: void,
    billingPartiesInMyGroup?: void,
    billingParties: {
        data: BillingParty[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const gqlBillingParty = `
    id
    overduePayments
    cost
    outstandingBalance
    hasPendingECheckPayments
    code
    totalCreditCardFees

    payingMembers {
        id
        primary_paying_member
        first_name
        last_name
        email
    }
    booking {
        id
        start_date
        end_date

        group {
            id
            booking_form_url
            name
            description_checkin

            tour {
                id
                display_name
            }

            hotel {
                id
                display_name
            }
        }
    }
    members {
        id
    }
`;

const GET_BILLING_PARTIES_QUERY = gql`
  query billingParties($first: Int!, $page: Int!, $where: WhereConditions, $hasGroupBooking: QueryBillingPartiesHasGroupBookingWhereHasConditions, $hasBillingPartyMember: QueryBillingPartiesHasBillingPartyMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    billingParties(first: $first, page: $page, where: $where, hasGroupBooking: $hasGroupBooking, hasBillingPartyMember: $hasBillingPartyMember, orderBy: $orderBy){
      data {
        ${gqlBillingParty}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

const getBillingParties = (first: number, page: number, where?: any, orderBy?: any, hasGroupBooking?: any, hasBillingPartyMember?: any) => useQuery<BillingPartiesData>(
    GET_BILLING_PARTIES_QUERY,
    {
        variables: {
            first,
            page,
            where,
            hasGroupBooking,
            hasBillingPartyMember,
            orderBy,
        },
    }
);

export default getBillingParties;
